module.exports = __webpack_public_path__ + "static/clothing-necklace-d8ba6c6aebd1cda127d5ab4c7f7476e4.jpg";